@if (record()?.ExternalFiles?.items?.length) {
    <mat-chip-listbox>
        @for (attachment of record().ExternalFiles.items; track attachment.guid) {
            <mat-chip
                removable
                (click)="downloadAttachment(attachment)"
                (removed)="removeAttachment(attachment)">
                {{ attachment.title }}
                <button
                    matChipRemove
                    [attr.aria-label]="'remove ' + attachment.guid">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip>
        }
    </mat-chip-listbox>
}

<mat-chip-listbox>
    @for (item of linkedRecords(); track item?.Guid) {
        <mat-chip removable>
            <mat-icon>satellite_alt</mat-icon>
            {{ item?.Title }}
        </mat-chip>
    }
</mat-chip-listbox>

@if (!isAndroidWrapper() && editable()) {
    <div
        class="st-attachments-list-upload"
        ngFileDrop
        [class.st-attachments-list-upload--dragging]="dragOver()"
        (uploadOutput)="onUploadOutput($event)">
        <span>{{ languageSettings.PSTWebAttachmentsListDragFile }}</span>
        <button
            class="st-attachments-list-upload-browse"
            [disabled]="disabled()"
            (click)="browse()">
            {{ languageSettings.PSTWebBrowseButtonLabel }}
        </button>
        <input
            #file
            type="file"
            ngFileSelect
            [disabled]="disabled()"
            [hidden]="true"
            (uploadOutput)="onUploadOutput($event)" />
    </div>
}

<!-- TODO: responsive -->
<!-- <div class="st-attachments-list-upload"
     *ngIf="isAndroidWrapper && editable"
     (click)="fireUploadEvent($event)">
    <label [attr.for]="(id ? id + 'FileInput' : null)">
        <span class="left pointer icon-Add mleft20"></span>
    </label>
    <input #attachment
           [attr.id]="(id ? id + 'FileInput' : null)"
           multiple="multiple"
           class="upload-file pointer"
           type="file" />
</div> -->
